//scoll based animations


function sba(){
    scrollAndShowTargetImage();
    backgroundColorChanger();
    needScroll();

    gallery();
}


function backgroundColorChanger(){

    (function($){
        if($(".background-color-trigger").length != 0){


            $( ".background-color-trigger" ).each(function() {
                var body_class = $( this ).data('bodyclass');
                var to_remove = $( this ).data('bctr');

                var trigger = gsap.timeline({
                    scrollTrigger: {
                        trigger: $( this ),
                        start : "top bottom",
                        end : "top bottom",
                        scrub : true,
                        onEnter: ({progress, direction, isActive}) => $('body').addClass(body_class).removeClass(to_remove),
                        onEnterBack: ({progress, direction, isActive}) => $('body').removeClass(body_class).addClass(to_remove),
                    }
                });


            });

        }
    })
    (jQuery)

}


function needScroll(){

    (function($){
        if($(".need-scroll-section").length != 0){

            

            $( ".need-scroll-section" ).each(function() {
                var body_class = 'need-scroll';
                var negative = $( this ).data('negative');
                if(negative){
                    body_class += " scroll-element-negative";
                }

                var trigger_enter = gsap.timeline({
                    scrollTrigger: {
                        trigger: $( this ),
                        start : "top top",
                        end : "+=100",
                        scrub : true,
                        onEnter: ({progress, direction, isActive}) => $('body').addClass(body_class),
                        onEnterBack: ({progress, direction, isActive}) => $('body').removeClass(body_class),
                    }
                });

                var trigger_exit = gsap.timeline({
                    scrollTrigger: {
                        trigger: $( this ),
                        start : "bottom bottom",
                        end : "+=100",
                        scrub : true,
                        onEnter: ({progress, direction, isActive}) => $('body').removeClass(body_class),
                        onEnterBack: ({progress, direction, isActive}) => $('body').addClass(body_class),
                    }
                });


            });

        }
    })
    (jQuery)

}




function scrollAndShowTargetImage(){


    (function($){


        if($(".sba-2-col-scroll-and-show").length != 0){

            var first_x = $(".ancored-image-overflow").data('x');
            var first_y = $(".ancored-image-overflow").data('y');
            var position = calcPositionOnImg(first_x, first_y,0, '.ancored-image' , '.ancored-image-overflow');

            var trigger_class = ".sba-tigger";

            //$(".ancored-image").css('top', position.top + "%");
            //$(".ancored-image").css('left',position.left + "%");

            for(t=0; t<= $(".sba-ancor-image .trigger-container " + trigger_class).length; t++){

                var x = $('#sns-trigger-' + t).data('x');
                var y = $('#sns-trigger-' + t).data('y');
                var z = $('#sns-trigger-' + t).data('z');

                var position = calcPositionOnImg(x,y,z, '.ancored-image' , '.ancored-image-overflow');

                var trigger_image = gsap.timeline({
                    scrollTrigger: {
                        trigger: '#sns-trigger-' + t,
                        start : "top top",
                        end : "+=250px",
                        scrub : true
                    }
                });

                var trigger_text = gsap.timeline({
                    scrollTrigger: {
                        trigger: '#sns-trigger-' + t,
                        start : "top top",
                        end : "+=250px",
                        scrub : true
                    }
                });

                var trigger_text_exit = gsap.timeline({
                    scrollTrigger: {
                        trigger: '#sns-trigger-' + t,
                        start : "bottom top",
                        end : "+=100px",
                        scrub : true
                    }
                });


                trigger_image.to('.ancored-image', {
                    top: position.top +'%',
                    left: position.left +'%',
                    width: z +'%',
                    //opacity: 1
                });

                trigger_text.to('#sns-text-' + t, {
                    top: 0,
                    opacity: 1,
                    display: 'block'
                });

                trigger_text_exit.to('#sns-text-' + t, {
                    top: '-3rem',
                    opacity: 0
                });

                

            }

 
        }



    })
    (jQuery);

    

}



function calcPositionOnImg(x,y,z, image, container){



        //var top_spacing = 150;
        var c_height = jQuery(container).height();
        var c_width = jQuery(container).width();
        var i_height = jQuery(image).height();
        var i_width = jQuery(image).width();
        var min_top = 0;
        
        if(i_height< c_height){
            min_top = c_height - i_height;
        }

        min_top_percent = min_top * 100 / c_height;
        
        


        var top = 100 - y;
        var left  = 100 - x;

        var position = {
            top : top,
            left : left,
            c_height : c_height,
            i_height : i_height,
            min_top : min_top_percent,
            x: x,
            y: y
        };

        //console.log(position);
        
        return position;



    
}


function gallery(){

    (function($){

        var wrapper_class = ".gallery-wrapper";
        var i = 0;

        $( wrapper_class ).each(function() {

            $('.carousel-gallery').css("overflow", "visible");
            var scrollWidth = $(this)[0].scrollWidth;
            $('.carousel-gallery').css("overflow", "hidden");
            //$('body').css("overflow-x", "hidden");

        

            if(i == 0){
                x = '100%';
                xEnd = (scrollWidth - $(this).width())  * -1;
                //xEnd = scrollWidth * -1;
                i=1;
                
            }else{
                x =  scrollWidth * -1;
                xEnd = 0;
                i=0;
            }


            gsap.fromTo($(this), { x }, {
                x: xEnd,
                scrollTrigger: {
                    trigger: $(this),
                    start : "center bottom",
                    end : "center top",
                    scrub: 0.5 
                }
            });

        });


    })
    (jQuery);

    

}

